import { GenericError } from '../../../errors/shared/genericError.js';
import { convertMetaToKVCollection } from './ExceptionData.js';

function createELKErrorLog(params) {
    const { level, message: error, meta = {} } = params;
    const date = new Date().toISOString();
    let exception;
    let exceptionType;
    let exceptionData;
    if (GenericError.isLike(error)) {
        const result = formatErrorDetails(error, meta);
        exception = result.message;
        exceptionData = result.details;
        exceptionType = error.domain;
    }
    else {
        exception = error.stack || getErrorTitle(error);
        exceptionType = `system-logger.unknown-domain.${error.name}`;
        exceptionData = meta;
    }
    return {
        date,
        level,
        message_type: 'app',
        exception_message: error.message,
        exception,
        exception_type: exceptionType,
        exception_data: convertMetaToKVCollection(exceptionData),
    };
}
function formatErrorDetails(err, meta) {
    let subErr = err.details;
    if (!subErr) {
        return { message: getErrorStack(err), details: meta };
    }
    const errHead = getErrorTitle(err);
    if (!GenericError.isLike(subErr)) {
        if (subErr instanceof Error) {
            return { message: `${errHead}\n${getErrorStack(subErr)}`, details: meta };
        }
        else {
            return { message: getErrorStack(err), details: Object.assign({}, subErr, meta) };
        }
    }
    let message = errHead;
    let details = meta;
    let stack = err.stack || '';
    while (GenericError.isLike(subErr)) {
        message += `\nCaused by: [${subErr.domain}] ${getErrorTitle(subErr)}`;
        stack = getErrorStack(subErr);
        stack = stack.substring(stack.indexOf('\n') + 1);
        subErr = subErr.details;
    }
    message += '\n';
    if (subErr) {
        if (subErr instanceof Error) {
            stack = getErrorStack(subErr);
        }
        else {
            details = Object.assign({}, subErr, meta);
        }
    }
    message += stack;
    return {
        message,
        details,
    };
}
function getErrorStack(err) {
    const stack = err.stack || '';
    let message = '';
    if (!stack.startsWith(err.name || err.constructor.name)) {
        message += `${getErrorTitle(err)}\n`;
    }
    message += stack;
    return message;
}
function getErrorTitle(err) {
    return `${err.name || err.constructor.name}: ${err.message}`;
}
function createELKMessageLog(params) {
    const { level, message, meta = {} } = params;
    const date = new Date().toISOString();
    return {
        date,
        level,
        message,
        message_type: 'app',
        exception_data: convertMetaToKVCollection(meta),
    };
}

export { createELKErrorLog, createELKMessageLog };
//# sourceMappingURL=ELKLogs.js.map
